import styled from 'styled-components';
import newHeaderBg from 'assets/images/login/new_header_bg.svg';
import headerBG from 'assets/images/login/header_bg.svg';
import logoImage from 'assets/images/login/logo.svg';
import infographic from 'assets/images/login/header_infographics.svg';

export const Wrapper = styled.div`
  position: relative;
  background-color: white;
  width: 100%;
  height: 100%;
  min-width: 1280px;
  &:before {
    content: '';
    width: 100%;
    height: 780px;
    background: url(${newHeaderBg}) no-repeat center -223px, linear-gradient(180deg, #eaf2ff 39.58%, #c3d8ff 100%);
    display: block;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const HeaderContent = styled.div`
  position: relative;
  min-height: 540px;
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  width: 1002px;
  min-height: 540px;
  margin: 0 auto;
  padding-top: 55px;
  padding-left: 34px;
  background-image: url(${headerBG});
  background-position: center top;
  background-repeat: no-repeat;
  font-size: 18px;
  line-height: 24px;
  color: rgba(9, 21, 38, 0.85);
  transform: translate(-34px, 0);
`;

export const HeaderTextWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  width: 484px;
  padding: 48px 0 0 64px;
`;

export const Logo = styled.div`
  width: 100px;
  height: 16px;
  background-image: url(${logoImage});
  background-position: center top;
  background-repeat: no-repeat;
`;

export const HeaderTitle = styled.h1`
  margin: 42px 0 16px 0;
  font-weight: bold;
  font-size: 32px;
  line-height: 44px;
`;

export const HeaderText = styled.p``;

export const Infographic = styled.div`
  margin-top: 44px;
  width: 357px;
  height: 150px;
  background-image: url(${infographic});
  background-position: center top;
  background-repeat: no-repeat;
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 484px;
  padding: 48px 92px 0 104px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.6);
  a:hover,
  a:focus,
  a:active,
  a:visited,
  a {
    text-decoration: none;
  }
  b {
    font-weight: bold;
  }
`;

export const LoginTitle = styled.span`
  margin-bottom: 42px;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: bold;
  color: rgba(9, 21, 38, 0.85);
`;

export const Fields = styled.div`
  width: 100%;
  margin-bottom: 44px;
`;

export const SubmitWrapper = styled.div``;

export const SubmitButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  width: 288px;
  padding: 0;
  background-color: #9965f4;
  border-radius: 10px;
  border: none;
  box-shadow: none;
  color: #fff;
  text-align: center;
  font-size: 14px;
  line-height: 19px;
  font-weight: bold;
  text-transform: uppercase;
  transition: background-color 0.125s ease-in-out;
  &:focus,
  &:hover {
    background-color: #803ef1;
  }
`;

export const Validation = styled.div`
  width: 100%;
  height: 20px;
  margin: 14px 0;
  padding: 0;
  text-align: center;
  color: #ff6170;
`;

export const HelpWrapper = styled.div``;

export const Help = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
`;

export const Link = styled.a`
  color: #11b7e7 !important;
  a:hover,
  a:focus,
  a:active,
  a:visited {
    color: #11b7e7;
  }
`;

export const Bold = styled.span`
  font-weight: bold;
`;

export const Content = styled.div`
  width: 1280px;
  margin: 59px auto 8px;
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;
  justify-content: center;
  position: relative;
`;

export const Info = styled.div`
  width: 310px;
  text-align: center;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 64px;
`;

export const H5 = styled.h5`
  margin-top: 22px;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  b {
    font-weight: bold;
  }
  a {
    &:hover {
      text-decoration: underline;
    }
    text-decoration: none;
  }
`;

export const Image = styled.img``;

export const Title = styled.div`
  color: rgba(65, 83, 226, 1);
  font-size: 24px;
  font-weight: 400;
`;

export const Decorate = styled.div`
  position: absolute;
  overflow: hidden;
  top: 462px;
  width: 100%;
  height: 500px;
  &:before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 40%;
    background: #fff;
    top: 0;
    width: 1920px;
    height: 889.918px;
  }
`;

export const AccessRequest = styled.a`
  color: rgba(153, 101, 244, 1);
  font-size: 16px;
  line-height: 22px;
  &:active,
  &:visited,
  &:hover {
    color: #7f39fb;
  }
`;
